import { apiCall } from './gqlClient';

const GETPLANS_QUERY = `
  query getPlans {
    getPlans
    {
      id
			title
			originalId
			name
			active
			amount
			interval
			offers
			description
			providerType
      ...fragments
    }
  }`;

export const getPlansApiCall = async (fragments = null) => apiCall({ query: GETPLANS_QUERY, variables: {}, fragments });
